import type { SVGComponentProps } from 'BreetHelpers';

export const TopUpMinimumIcon = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='32'
		height='32'
		viewBox='0 0 32 32'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<rect
			width='32'
			height='32'
			rx='16'
			fill='#F7F8F8'
		/>
		<path
			d='M15.5 13.3867V15.2934L14.8267 15.0601C14.4867 14.9401 14.28 14.8267 14.28 14.2467C14.28 13.7734 14.6334 13.3867 15.0667 13.3867H15.5Z'
			fill='#022745'
		/>
		<path
			d='M17.72 17.7535C17.72 18.2268 17.3667 18.6135 16.9333 18.6135H16.5V16.7068L17.1733 16.9401C17.5133 17.0601 17.72 17.1735 17.72 17.7535Z'
			fill='#022745'
		/>
		<path
			d='M18.7933 9.33325H13.2066C10.7799 9.33325 9.33325 10.7799 9.33325 13.2066V18.7933C9.33325 21.2199 10.7799 22.6666 13.2066 22.6666H18.7933C21.2199 22.6666 22.6666 21.2199 22.6666 18.7933V13.2066C22.6666 10.7799 21.2199 9.33325 18.7933 9.33325ZM17.5066 15.9999C18.0266 16.1799 18.7199 16.5599 18.7199 17.7533C18.7199 18.7799 17.9199 19.6133 16.9333 19.6133H16.4999V19.9999C16.4999 20.2733 16.2733 20.4999 15.9999 20.4999C15.7266 20.4999 15.4999 20.2733 15.4999 19.9999V19.6133H15.2599C14.1666 19.6133 13.2799 18.6866 13.2799 17.5533C13.2799 17.2799 13.4999 17.0533 13.7799 17.0533C14.0533 17.0533 14.2799 17.2799 14.2799 17.5533C14.2799 18.1399 14.7199 18.6133 15.2599 18.6133H15.4999V16.3533L14.4933 15.9999C13.9733 15.8199 13.2799 15.4399 13.2799 14.2466C13.2799 13.2199 14.0799 12.3866 15.0666 12.3866H15.4999V11.9999C15.4999 11.7266 15.7266 11.4999 15.9999 11.4999C16.2733 11.4999 16.4999 11.7266 16.4999 11.9999V12.3866H16.7399C17.8333 12.3866 18.7199 13.3133 18.7199 14.4466C18.7199 14.7199 18.4999 14.9466 18.2199 14.9466C17.9466 14.9466 17.7199 14.7199 17.7199 14.4466C17.7199 13.8599 17.2799 13.3866 16.7399 13.3866H16.4999V15.6466L17.5066 15.9999Z'
			fill='#022745'
		/>
	</svg>
);
